<template>
  <div class="container body">
    <div class="main_container">
      <div
        v-if="!isMobileViewport"
        class="col-md-3 left_col no-print netpa-sidebar"
      >
        <div :class="GetMode()">
          <div
            class="navbar nav_title text-center mt-1 no-print"
            style="border: 0"
          >
            <a
              href="#"
              class="site_title"
              style="overflow: visible !important; line-height: 15px !important"
              ><i
                class="fas fa-home headerlogo"
                style="font-size: 15px !important; overflow: visible !important"
              ></i
              ><span
                style="font-weight: 400 !important; font-size: 11px !important"
              >
                {{ this.$session.get("UserInfoNetPa").customerName }}
              </span>
            </a>
          </div>

          <div class="clearfix"></div>

          <!-- menu profile quick info -->
          <div class="profile clearfix pb-3">
            <div class="row mt-3">
              <div class="col-12 col-md-4 text-center">
                <div class="mt-3" style="margin-right: 30%">
                  <img
                    src="/Template/NewMenu/img/userNew.jpg"
                    alt="..."
                    class="rounded"
                    width="100%"
                  />
                </div>
              </div>

              <div class="col-12 col-md-8 text-center">
                <div class="text-right">
                  <span class="text-light d-block">مشخصات </span>
                  <span class="text-warning">{{
                    this.$session.get("UserInfoNetPa").ozvName +
                    " " +
                    this.$session.get("UserInfoNetPa").ozvFamily
                  }}</span>
                </div>
                <div class="text-right mt-1">
                  <span class="text-light d-block">آخرین ورود</span>
                  <span class="text-warning">{{
                    $session.get("UserInfoNetPa").axarinVorodBeSite
                  }}</span>
                </div>
              </div>
            </div>

            <div class="row mt-1">
              <div class="col-12">
                <div class="text-warning text-center pb-3 mt-3">
                  <span class="text-light">IP: </span>{{ UserIp }}
                </div>
              </div>
            </div>
            <div class="row text-center">
              <div class="col-12 text-center">
                <input
                  value="10:00"
                  name="b_Timer"
                  id="b_Timer"
                  style="font-family: IRANSansWeb !important"
                  readonly="true"
                  tabindex="-1"
                  dir="rtl"
                  class="text-center w-100 text-light"
                  title="پس از اين زمان شما بصورت خودکار از سامانه خارج خواهيد شد"
                />
              </div>
            </div>
          </div>

          <!-- /menu profile quick info -->
          <hr />
          <!-- sidebar menu -->
          <div id="sidebar-menu" class="main_menu_side hidden-print main_menu">
            <h3
              style="color: #f38905; font-weight: normal"
              class="text-right mr-2"
            >
              منو سامانه
            </h3>
            <div class="menu_section">
              <ul class="nav side-menu">
                <li style="width: 100%">
                  <router-link :to="{ name: 'Home' }">
                    <i
                      class="fas fa-home"
                      style="font-size: 18px !important; color: #f38905"
                    ></i>
                    <span class="font-small mr-3 text-center text-justify">{{
                      Pishkhan.name
                    }}</span>
                  </router-link>
                </li>
                <!-- راهـــــــــبری پورتال -->
                <li style="width: 100%" v-if="$session.get('IsRahbar')">
                  <a href="javascript:void(0)">
                    <i
                      class="fas fa-user-shield"
                      style="font-size: 18px !important; color: #f38905"
                    ></i>
                    <span class="font-small mr-3 text-center matn"
                      >راهبر سیستم</span
                    >
                    <span
                      class="remove-sm fas fa-chevron-down float-left"
                    ></span>
                  </a>
                  <ul class="nav child_menu">
                    <li class="sub_menu">
                      <router-link :to="{ name: 'Accessability' }">
                        دسترسی منوها
                      </router-link>
                    </li>
                    <li class="sub_menu">
                      <router-link :to="{ name: 'Gateway' }">
                        تنظیمات
                      </router-link>
                    </li>
                    <li class="sub_menu">
                      <router-link :to="{ name: 'UsersSetting' }"
                        >بررسی وضعیت کاربران
                      </router-link>
                    </li>
                    <li class="sub_menu" v-if="isWebSiteView">
                      <router-link :to="{ name: 'WebSiteSetting' }"
                        >تنظیمات سایت</router-link
                      >
                    </li>
                    <li class="sub_menu">
                      <router-link :to="{ name: 'MangeDownloadForms' }"
                        >مدیریت فایلها
                      </router-link>
                    </li>
                    <li
                      v-if="
                        $session.get('IsRahbar') &&
                        $session.get('CustCode') == '801'
                      "
                    >
                      <a href="javascript:;" @click="GotoToTabloo()">
                        <span
                          class="font-small text-justify w-100 mr-3 text-center font-small matn"
                          >ثبت تابلو اعلانات</span
                        >
                      </a>
                    </li>
                    <li v-if="$session.get('IsRahbar')">
                      <router-link :to="{ name: 'SettingVam' }">
                        تنظیمات درخواست وام
                      </router-link>
                    </li>
                    <li v-if="$session.get('IsRahbar')">
                      <router-link :to="{ name: 'FAQManagement' }">
                        پرسش و پاسخ‌های متداول
                      </router-link>
                    </li>
                  </ul>
                </li>
                <!-- درخواســـت ها برای مشتـــری 932 تامین اجتمــاعی -->
                <li
                  style="width: 100%"
                  v-if="
                    $session.get('IsRahbar') &&
                    ($session.get('CustCode') == '932' ||
                      $session.get('CustCode') == '8002')
                  "
                >
                  <a href="javascript:void(0)">
                    <i
                      class="fas fa-search"
                      style="font-size: 18px !important; color: #f38905"
                    ></i>
                    <span class="font-small mr-3 text-center matn"
                      >لیست درخواست ها
                    </span>
                    <span
                      class="remove-sm fas fa-chevron-down float-left"
                    ></span>
                  </a>
                  <ul class="nav child_menu">
                    <li class="sub_menu">
                      <router-link :to="{ name: 'ListVamRequests' }">
                        درخواست های وام
                      </router-link>
                    </li>
                    <li class="sub_menu">
                      <router-link :to="{ name: 'ListRegisterRequests' }">
                        درخواست های عضویت
                      </router-link>
                    </li>
                    <li class="sub_menu">
                      <router-link :to="{ name: 'ListRequestLetterEnseraf' }">
                        درخواست های انصراف
                      </router-link>
                    </li>
                    <li class="sub_menu">
                      <router-link
                        :to="{ name: 'ListRequestLetterSodorEsterdad' }"
                      >
                        درخواست های استرداد سپرده</router-link
                      >
                    </li>
                    <li class="sub_menu">
                      <router-link
                        :to="{ name: 'ListRequestLetterTaghirAghsat' }"
                      >
                        درخواست های تغییر اقساط
                      </router-link>
                    </li>
                    <li class="sub_menu">
                      <router-link
                        :to="{ name: 'ListRequestLetterTaghirModatSepordeh' }"
                      >
                        درخواست های تغییر مدت سپرده
                      </router-link>
                    </li>
                    <li class="sub_menu">
                      <router-link :to="{ name: 'ListAzaFile' }">
                        دریافت فایل
                      </router-link>
                    </li>
                  </ul>
                </li>
                <li style="width: 100%" v-if="$session.get('ModirShobe')">
                  <a href="javascript:void(0)">
                    <i
                      class="fas fa-user-shield"
                      style="font-size: 18px !important; color: #f38905"
                    ></i>
                    <span class="font-small mr-3 text-center matn"
                      >مدیر شعبه</span
                    >
                    <span
                      class="remove-sm fas fa-chevron-down float-left"
                    ></span>
                  </a>
                  <ul class="nav child_menu">
                    <li class="sub_menu">
                      <router-link :to="{ name: 'ManagUsers' }">
                        مدیریت کاربران
                      </router-link>
                    </li>
                    <li
                      v-if="$session.get('UserInfoNetPaModirShobe') != null"
                      class="sub_menu"
                    >
                      <a href="javascript:;" @click="GotoModirShobe()">
                        <span
                          class="font-small text-justify w-100 mr-3 text-center font-small matn"
                          >بازگشت به پنل مدیر</span
                        >
                      </a>
                    </li>
                    <li
                      v-if="
                        $session.get('ModirShobe') &&
                        $session.get('CustCode') == '801'
                      "
                    >
                      <a href="javascript:;" @click="GotoToTabloo()">
                        <span
                          class="font-small text-justify w-100 mr-3 text-center font-small matn"
                          >ثبت تابلو اعلانات</span
                        >
                      </a>
                    </li>
                    <li
                      v-if="
                        $session.get('ModirShobe') &&
                        $session.get('CustCode') == '801'
                      "
                    >
                      <a href="javascript:;" @click="GoToSettingVam()">
                        <span
                          class="font-small text-justify w-100 mr-3 text-center font-small matn"
                          >تنظیمات درخواست وام</span
                        >
                      </a>
                    </li>
                  </ul>
                </li>

                <li
                  v-for="(item, index) in mainMenuLi"
                  :key="index"
                  style="width: 100%"
                >
                  <a href="javascript:void(0)">
                    <i
                      :class="item.menuIcone"
                      style="font-size: 18px !important; color: #f38905"
                    ></i>
                    <span
                      class="font-small text-justify w-100 mr-3 text-center font-small matn"
                      >{{ item.name }}</span
                    >
                    <span
                      class="remove-sm fas fa-chevron-down float-left"
                    ></span>
                  </a>
                  <ul class="nav child_menu">
                    <li
                      class="sub_menu"
                      v-for="(menu, index) in Getchild(item.id)"
                      :key="index"
                    >
                      <router-link
                        :to="{
                          name: menu.routeName,
                          params: menu.params != null ? menu.params : '',
                        }"
                        >{{ menu.name }}</router-link
                      >
                    </li>
                  </ul>
                </li>
              </ul>
              <div></div>
            </div>
          </div>
          <!-- sidebar menu -->

          <!-- menu footer buttons -->
          <div class="sidebar-footer hidden-small">
            <!-- <a  href="javascript:;" @click.prevent="SettingUser"  title="تنظیمات کاربری">
                            <span class="glyphicon glyphicon-cog" aria-hidden="true"></span>
                        </a>
                        <a href="javascript:;" @click.prevent="FullScreen" title="FullScreen">
                            <span class="glyphicon glyphicon-fullscreen" aria-hidden="true"></span>
                        </a>
                        <a data-toggle="tooltip" data-placement="top" title="Lock">
                            <span class="glyphicon glyphicon-eye-close" aria-hidden="true"></span>
                        </a> -->
            <!-- <a  href="javascript:;" @click.prevent="LogOut()"  title="خروج">
                            <span class="glyphicon glyphicon-off" aria-hidden="true"></span>
                        </a> -->
            <!-- <router-link :to="{name:'TestAxios'}">
                            <span class="glyphicon glyphicon-off" aria-hidden="true"></span>
                        </router-link> -->
          </div>
          <!-- menu footer buttons -->
        </div>
      </div>

      <!-- top navigation -->
      <div class="top_nav no-print">
        <div class="nav_menu">
          <nav class="nav navbar-nav text-left pl-5">
            <div class="row">
              <div class="col-2 netpa-menu-toggle">
                <div class="nav toggle float-right pt-2">
                  <a id="menu_toggle"
                    ><i
                      class="fa fa-bars"
                      style="font-size: 26px !important"
                    ></i
                  ></a>
                </div>
              </div>
              <div class="col-10">
                <ul
                  class="nav navbar-right"
                  :class="{ 'netpa-header-has-cart': GetCart > 0 }"
                  dir="ltr"
                  style="
                    display: contents;
                    -ms-flex-wrap: wrap;
                    flex-wrap: inherit;
                  "
                >
                  <li class="open" style="padding-left: 15px">
                    <a
                      href="javascript:;"
                      class="user-profile dropdown-toggle"
                      aria-haspopup="true"
                      id="navbarDropdown"
                      data-toggle="dropdown"
                      aria-expanded="false"
                    >
                      <img src="/Template/NewMenu/img/userNew.jpg" alt="" />
                      <span class="mr-2"
                        >{{
                          this.$session.get("UserInfoNetPa").ozvName +
                          " " +
                          this.$session.get("UserInfoNetPa").ozvFamily
                        }}
                      </span>
                    </a>
                    <div
                      dir="rtl"
                      class="dropdown-menu dropdown-usermenu pull-right text-right"
                      style="top: 15px !important; left: -90px !important"
                    >
                      <a
                        class="dropdown-item"
                        @click.prevent="LogOut()"
                        href="javascript:;"
                        ><i class="fa fa-sign-out float-left"></i> خروج</a
                      >
                    </div>
                  </li>
                  <li
                    v-if="GetCart > 0"
                    class="open netpa-header-cart-item"
                    style="padding-left: 15px"
                  >
                    <a
                      href="javascript:;"
                      class="user-profile"
                      @click="GoToCart()"
                    >
                      <i
                        class="fas fa-shopping-bag text-danger bounce"
                        style="font-size: 18px !important"
                      ></i
                      ><b class="ml-2 text-danger">{{ GetCart }}</b>
                    </a>
                  </li>
                </ul>
              </div>
            </div>
          </nav>
        </div>
      </div>
      <!-- top navigation -->

      <!-- page content -->
      <div class="right_col" role="main">
        <div class="">
          <div class="m-3 p-5" v-if="this.$route.name == 'Pishkhan'">
            <!-- <shortcut></shortcut> -->
          </div>
          <router-view></router-view>
        </div>
      </div>
      <!-- page content -->
      <footer>
        <!-- <div class="pull-right">
                    <router-link :to="{name:'ViewHistory'}" > [ نسخه  : {{this.$store.state.VersionSoftware}} ] </router-link>
                    <span class="text-default">[ سمت کاربر :  {{this.$session.get('UserInfo').gName}} ]</span>
                    <span> [ {{ this.$store.state.JalaliDateAndTime }} ] </span>
                </div> -->
        <div class="clearfix"></div>
      </footer>
      <mobile-bottom-nav
        v-if="bottomNavItems.length"
        variant="netpa"
        :items="bottomNavItems"
      />
    </div>
  </div>
</template>
<script>
import MobileBottomNav from '../MobileBottomNav.vue'
import {
  buildNetPaBottomNavItems,
  getCartBadgeCount,
  isMobileScreenWidth,
} from '../../../utils/mobileBottomNav'

export default {
  components: {
    MobileBottomNav,
  },
  data() {
    return {
      Route: '',
      AllMenu: {},
      mainMenuLi: [],
      Pishkhan: {},
      UserIp: '',
      isWebSiteView: false,
      isMobileViewport: false,
    }
  },
  methods: {
    syncMobileLayout() {
      this.isMobileViewport = isMobileScreenWidth()
      if (this.isMobileViewport) {
        document.body.classList.add('netpa-mobile-no-sidebar')
        document.body.classList.remove('netpa-has-sidebar')
      } else {
        document.body.classList.remove('netpa-mobile-no-sidebar')
        document.body.classList.add('netpa-has-sidebar')
      }
    },
    GotoModirShobe() {
      this.$session.set(
        "UserInfoNetPa",
        this.$session.get("UserInfoNetPaModirShobe"),
      );
      this.$session.set("UserInfoNetPaModirShobe", null);
      if (this.$router.name != "Home") {
        this.$router.push("/PishkhanNetPa/Home");
        window.location.reload();
      } else {
        window.location.reload();
      }
    },
    close() {
      document.getElementById("menu_toggle").click();
    },

    GoToPishkhan() {
      this.$router.push("/PishkhanNetPa");
    },
    GotoToTabloo() {
      this.$router.push("TablooElanat");
    },
    GoToSettingVam() {
      this.$router.push("SettingVam");
    },
    Getavatar() {
      return "/Image/avatar.jpg";
    },
    LogOut() {
      var DataAxios = {
        Method: "Post",
        Action: "Logout",
        ArryfildValue: {},
        Token: this.$session.get("TokenNetPa"),
      };
      this.$PostData(DataAxios).then((result) => {
        //console.log(result);
        this.$store.state.Netpa_Cart = [];
        this.$router.push("/");
        this.$session.clear();
        sessionStorage.removeItem("vuex");
        this.$store.state.PanelRout = [];
        this.$ResetTimer();
      });
    },
    GetMode() {
      var a = false;
      if (a == true) {
        return "left_col_Light scroll-view";
      } else {
        return "left_col scroll-view";
      }
    },
    GetMenus() {
      var result = this.$session.get("AllMenu");
      this.Pishkhan = result[0];
      result.forEach((element) => {
        if (element.params != null) {
          var withQuotes = element.params.replace(
            /(\b[a-z]+:)?(\b[a-z]+\b)/gi,
            '"$2"',
          );
          var parsed = JSON.parse(withQuotes);
          for (const [key, value] of Object.entries(parsed)) {
            if (value === "true") {
              parsed[key] = true;
            }
            if (value === "false") {
              parsed[key] = false;
            }
          }

          element.params = parsed;
        }
        this.AllMenu = result;
        if (element.isParentMenu == true) {
          this.mainMenuLi.push(element);
        }
      });
    },
    Getchild(id) {
      var childs = [];
      for (var i = 0; i < this.AllMenu.length; i++) {
        var element = this.AllMenu[i];
        if (element.parentId == id) {
          childs.push(element);
        }
      }
      return childs;
    },
    GoToCart() {
      if (this.$route.name != "Cart") {
        this.$router.push({
          name: "Cart",
        });
      }
    },
    reinitSidebar() {
      if (typeof window.reinitNetPaSidebar === "function") {
        window.reinitNetPaSidebar();
      }
    },
  },
  watch: {
    isMobileViewport(val, oldVal) {
      if (!val && oldVal) {
        this.$nextTick(() => this.reinitSidebar())
      }
    },
  },
  async created() {
    this.syncMobileLayout()
    this.GetMenus()
    this.isWebSiteView = await this.$IsWebSiteView()
    this.$nextTick(() => this.reinitSidebar())
  },
  mounted() {
    this.syncMobileLayout()
    window.addEventListener('resize', this.syncMobileLayout)
    this.$GetipClient()
      .then((data) => {        
        this.UserIp = data.data.ip;
      })
      .catch(() => {
        this.UserIp = "127.0.0.1";
      });
    this.$nextTick(() => this.reinitSidebar());
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.syncMobileLayout)
    document.body.classList.remove('netpa-mobile-no-sidebar')
    document.body.classList.remove('netpa-has-sidebar')
  },
  computed: {
    GetCart() {
      return getCartBadgeCount(this.$store)
    },
    bottomNavItems() {
      return buildNetPaBottomNavItems(this.$session, {
        isWebSiteView: this.isWebSiteView,
        allMenuRaw: this.$session.get('AllMenu'),
      })
    },
  },
};
</script>
<style scoped>
@media print {
  .no-print {
    display: none !important;
  }
  /* .print {
    display: block !important;
  } */
}
.nav-sm .nav.side-menu li a span.font-small {
  /* white-space: nowrap !important; */
  font-size: 0.6rem !important;
  margin-right: 0 !important;
}

#app {
  font-size: 14px;
}

#app * {
  font-size: 12px !important;
  clear: both !important;
}

.wrapper {
  font-size: 12px !important;
}

.main-sidebar {
  z-index: 1000 !important;
  height: 100vh;
  overflow-y: hidden;
}

i.fa-circle-o {
  color: rgb(187, 145, 6) !important;
}

.menu-open > a {
  background: rgb(121, 93, 4) !important;
}

.dropdown-menu-lg {
  min-width: 170px;
  max-width: 300px;
  padding: 0;
  text-align: center;
}

.nav-sm .headerlogo {
  margin-right: 25% !important;
}

.Nohover:hover {
  background: #ededed;
}

#b_Timer {
  width: 62px;
  background-color: transparent;
  margin-top: 15px;
  color: #2a3f54;
  border: none;
  text-align: center;
  float: left;
  font-size: 14px !important;
  font-family: tahoma;
  left: 1px;
}

.pull-right {
  text-align: right;
}

@media (max-width: 767px) {
  .netpa-menu-toggle {
    display: none !important;
  }
}
</style>
<style>
/* فاصله بین آیکن و متن منوی سایدبار */
.netpa-sidebar .nav.side-menu > li > a {
  display: flex !important;
  flex-direction: row;
  align-items: center;
  gap: 10px;
  clear: none !important;
}

.netpa-sidebar .nav.side-menu > li > a > i {
  flex: 0 0 auto;
  clear: none !important;
  float: none !important;
}

.netpa-sidebar .nav.side-menu > li > a > span.font-small,
.netpa-sidebar .nav.side-menu > li > a > span.matn {
  flex: 1 1 auto;
  min-width: 0;
  clear: none !important;
  float: none !important;
  margin-right: 0 !important;
}

.netpa-sidebar .nav.side-menu > li > a > span.remove-sm {
  flex: 0 0 auto;
  margin-inline-start: auto;
  clear: none !important;
  float: none !important;
}

/* سایدبار جمع‌شده: تایتل زیر آیکن + flyout زیرمنو بدون باز شدن کامل سایدبار */
body.netpa-has-sidebar.nav-sm #app .netpa-sidebar .nav.side-menu > li > a,
body.netpa-has-sidebar.nav-sm #app .netpa-sidebar .nav.side-menu > li > a > i,
body.netpa-has-sidebar.nav-sm #app .netpa-sidebar .nav.side-menu > li > a > span {
  clear: none !important;
}

body.netpa-has-sidebar.nav-sm .netpa-sidebar .nav.side-menu > li > a {
  flex-direction: column !important;
  align-items: center !important;
  justify-content: center !important;
  gap: 4px !important;
  text-align: center !important;
  padding: 10px 5px !important;
}

body.netpa-has-sidebar.nav-sm .netpa-sidebar .nav.side-menu > li > a > i {
  width: 100% !important;
  margin-bottom: 5px;
  font-size: 25px !important;
}

body.netpa-has-sidebar.nav-sm .netpa-sidebar .nav.side-menu > li > a > span.font-small,
body.netpa-has-sidebar.nav-sm .netpa-sidebar .nav.side-menu > li > a > span.matn {
  flex: 0 0 auto !important;
  width: 100% !important;
  text-align: center !important;
  font-size: 0.6rem !important;
  line-height: 1.2;
  white-space: normal !important;
}

body.netpa-has-sidebar.nav-sm .netpa-sidebar .nav.side-menu > li > a > span.remove-sm {
  display: none !important;
}

/* flyout زیرمنو بیرون سایدبار (سمت چپ در RTL) — موقعیت با position:fixed در custom.js */
body.netpa-has-sidebar.nav-sm .netpa-sidebar .nav.side-menu > li {
  position: relative;
}

body.netpa-has-sidebar.nav-sm .netpa-sidebar ul.nav.child_menu {
  position: fixed !important;
  left: auto !important;
  right: auto !important;
  width: 210px !important;
  margin: 0 !important;
  padding: 0 !important;
  border: none !important;
  box-shadow: none !important;
  transition: none !important;
  animation: none !important;
  z-index: 4001 !important;
  background: #3e5367 !important;
  text-align: right !important;
}

body.netpa-has-sidebar.nav-sm .netpa-sidebar ul.nav.child_menu li {
  padding: 0 10px !important;
}

body.netpa-has-sidebar.nav-sm .netpa-sidebar ul.nav.child_menu li a {
  text-align: right !important;
}

body.netpa-has-sidebar.nav-sm .netpa-sidebar .nav.side-menu li.active-sm {
  border-right: none !important;
  border-left: 5px solid #1abb9c;
}

#app .top_nav .nav_menu {
  padding-left: var(--netpa-content-inline-inset, 25px) !important;
  padding-right: var(--netpa-content-inline-inset, 25px) !important;
  box-sizing: border-box;
}

#app .top_nav .nav_menu .row {
  margin-left: 0;
  margin-right: 0;
  position: relative;
}

#app .top_nav .nav_menu .col-10 {
  flex: 0 0 100%;
  max-width: 100%;
  padding-left: 0;
  padding-right: 0;
}

#app .top_nav .nav_menu nav.navbar-nav {
  padding-left: 0 !important;
  padding-right: 0 !important;
}

#app .top_nav .nav_menu ul.nav.navbar-right {
  display: flex !important;
  flex-wrap: nowrap;
  align-items: center;
  justify-content: flex-start !important;
  width: 100%;
  margin: 0;
  padding: 0;
}

#app .top_nav .nav_menu .navbar-right > li {
  float: none !important;
  display: flex !important;
  align-items: center;
  padding-left: 0 !important;
}

#app .top_nav .user-profile,
#app .top_nav .user-profile img,
#app .top_nav .user-profile span {
  clear: none !important;
  float: none !important;
}

#app .top_nav .user-profile {
  display: inline-flex !important;
  align-items: center;
  flex-wrap: nowrap;
  max-width: 100%;
}

#app .top_nav .user-profile span {
  display: inline !important;
  visibility: visible !important;
  white-space: nowrap;
  font-size: 12px !important;
  color: #5e6974 !important;
  max-width: calc(100% - 48px);
  overflow: hidden;
  text-overflow: ellipsis;
}

@media (min-width: 768px) {
  #app .top_nav .nav_menu .netpa-menu-toggle {
    position: absolute;
    right: 0;
    top: 0;
    bottom: 0;
    display: flex !important;
    align-items: center;
    width: auto;
    max-width: none;
    flex: 0 0 auto;
    padding: 0;
    z-index: 2;
  }

  #app .top_nav .nav_menu .col-10 {
    padding-right: 2.75rem;
  }

  #app .top_nav .user-profile span {
    font-size: 13px !important;
  }
}

@media (max-width: 767px) {
  body.netpa-mobile-no-sidebar .container.body .right_col,
  body.netpa-mobile-no-sidebar .container.body .top_nav,
  body.netpa-mobile-no-sidebar .main_container .top_nav,
  body.netpa-mobile-no-sidebar .top_nav .nav_menu,
  body.netpa-mobile-no-sidebar footer {
    margin-right: 0 !important;
    margin-left: 0 !important;
    width: 100% !important;
    max-width: 100% !important;
    left: 0 !important;
  }

  #app .top_nav .nav_menu ul.nav.navbar-right.netpa-header-has-cart {
    justify-content: space-between !important;
  }

  #app .top_nav .netpa-header-cart-item {
    order: -1;
    padding-left: 0 !important;
  }

  #app
    .top_nav
    .nav_menu
    ul.nav.navbar-right.netpa-header-has-cart
    > li.open:not(.netpa-header-cart-item) {
    margin-left: auto;
  }
}
/* width */

.bounce {
  -webkit-animation-name: bounceIn;
  animation-name: bounceIn;
  -webkit-animation-duration: 0.75s;
  animation-duration: 0.75s;
  -webkit-animation-duration: 1s;
  animation-duration: 1s;
  animation-iteration-count: infinite;
  -webkit-animation-fill-mode: both;
  animation-fill-mode: both;
}

@-webkit-keyframes bounceIn {
  0%,
  20%,
  40%,
  60%,
  80%,
  100% {
    -webkit-transition-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);
    transition-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);
  }

  0% {
    opacity: 0;
    -webkit-transform: scale3d(0.3, 0.3, 0.3);
    transform: scale3d(0.3, 0.3, 0.3);
  }

  20% {
    -webkit-transform: scale3d(1.1, 1.1, 1.1);
    transform: scale3d(1.1, 1.1, 1.1);
  }

  40% {
    -webkit-transform: scale3d(0.9, 0.9, 0.9);
    transform: scale3d(0.9, 0.9, 0.9);
  }

  60% {
    opacity: 1;
    -webkit-transform: scale3d(1.03, 1.03, 1.03);
    transform: scale3d(1.03, 1.03, 1.03);
  }

  80% {
    -webkit-transform: scale3d(0.97, 0.97, 0.97);
    transform: scale3d(0.97, 0.97, 0.97);
  }

  100% {
    opacity: 1;
    -webkit-transform: scale3d(1, 1, 1);
    transform: scale3d(1, 1, 1);
  }
}

@keyframes bounceIn {
  0%,
  20%,
  40%,
  60%,
  80%,
  100% {
    -webkit-transition-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);
    transition-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);
  }

  0% {
    opacity: 0;
    -webkit-transform: scale3d(0.3, 0.3, 0.3);
    transform: scale3d(0.3, 0.3, 0.3);
  }

  20% {
    -webkit-transform: scale3d(1.1, 1.1, 1.1);
    transform: scale3d(1.1, 1.1, 1.1);
  }

  40% {
    -webkit-transform: scale3d(0.9, 0.9, 0.9);
    transform: scale3d(0.9, 0.9, 0.9);
  }

  60% {
    opacity: 1;
    -webkit-transform: scale3d(1.03, 1.03, 1.03);
    transform: scale3d(1.03, 1.03, 1.03);
  }

  80% {
    -webkit-transform: scale3d(0.97, 0.97, 0.97);
    transform: scale3d(0.97, 0.97, 0.97);
  }

  100% {
    opacity: 1;
    -webkit-transform: scale3d(1, 1, 1);
    transform: scale3d(1, 1, 1);
  }
}
</style>
